/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */ export var styles = ['md-spinner[_ngcontent-%COMP%]{\r\n    display: block;\r\n    position: absolute;\r\n    bottom: 8vh;\r\n    left: 50%;\r\n    margin-left: -50px;\r\n}'];
//# sourceMappingURL=spinner.component.css.shim.ngstyle.js.map